<template>
    <a-list
        :data-source="list"
        bordered
        item-layout="horizontal"
        class="people-list"
    >
        <template #renderItem="{ item }">
            <a-list-item class="list-item" @click="select(item.id)">
                <template #actions>
                    <a-tooltip title="Visualizar">
                        <EyeOutlined
                            @click.stop="select(item.id)"
                            style="cursor: pointer; font-size: 18px;"
                        />
                    </a-tooltip>
                </template>

                <a-list-item-meta
                    :title="`${item.id} - ${item.ownerName}`"
                    class="item-text"
                />
            </a-list-item>
        </template>
    </a-list>
</template>

<script setup>
import { EyeOutlined } from "@ant-design/icons-vue";
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    properties: Array
})

const emits = defineEmits(['select-property'])

const list = computed(() => props.properties)

const select = (id) => {
    emits('select-property', id)
}
</script>

<style scoped>
.people-list .list-item {
    transition: background-color 0.2s ease;
}
.people-list .list-item:hover {
    background-color: #f0f5ff;
    cursor: pointer;
}
.item-text {
    font-weight: 500;
}
</style>
